import type { ComponentType } from 'react'
import GutsCheck from './GutsCheck'
import Diagnostic from './Diagnostic'
import Ari from './Ari'
import RoiCalculator from './RoiCalculator'

/**
 * Tool id → component.
 *
 * The one place a `kind: 'tool'` section is resolved, so a page stays copy and
 * the interactive part is a single entry in its `sections` array. Adding a tool
 * is a component and a line here; nothing in `ContentPage` changes.
 *
 * Keys match `website.tool_submissions.tool`'s check constraint and the slugs
 * in `src/worker/tools.ts`, deliberately — the same string names the tool in the
 * URL, in the payload, in the database and in the playbook, so there is nothing
 * to keep in step.
 */
export const TOOLS: Record<string, ComponentType> = {
  'agentic-guts-check': GutsCheck,
  'transformation-readiness': Diagnostic,
  'agentic-readiness-index': Ari,
  'roi-calculator': RoiCalculator,
}
